"use client";

import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { VideoPlayer } from "../custom-video-player/custom-video-player";

interface CustomVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoLink: string;
}

const CustomVideoModal = ({
  isOpen,
  onClose,
  videoLink,
}: CustomVideoModalProps) => {
  const modalRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      if (isOpen) {
        modalElement.showModal();
        document.body.style.overflow = "hidden";
      } else {
        modalElement.close();
      }
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (event: React.MouseEvent<HTMLDialogElement>) => {
    if (event.target === modalRef.current) {
      onClose();
    }
  };

  return createPortal(
    <dialog
      ref={modalRef}
      className="bg-transparent p-0 w-full h-full max-w-full max-h-full flex items-center justify-center backdrop:bg-black/80 focus:outline-none"
      onClick={handleBackdropClick}
    >
      <div className=" w-full max-w-[50dvh] px-5">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white z-10 text-2xl cursor-pointer"
        >
          &times;
        </button>


        <VideoPlayer
          type="application/x-mpegURL"
          videoLink={videoLink
          }
        />
                  
      </div>
    </dialog>,
    document.body
  );
};

export default CustomVideoModal;
